import axios from "axios";
import {GET_REFERAL_CANDI_TYPE} from "../types";
import {
    REFERAL_CANDI_API
} from "../../../utils/routes";
import setSuccessMessage from "../common/setSuccessMessage";
import setErrorMessage from "../common/setErrorMessage";
import getDispatch from "../common/getDispatch";

export const addCandidateReferal = (data, back) =>(dispatch) => {
  axios
    .post( REFERAL_CANDI_API, data, { withCredentials: true })
    .then((res) => {
      dispatch(setSuccessMessage(res, back,getCandidateReferal));
    })
    .catch((err) => {
      dispatch(setErrorMessage(err));
    });
};

export const getCandidateReferal = () => (dispatch) => {
  axios
    .get( REFERAL_CANDI_API, { withCredentials: true })
    .then((res) => {
      dispatch(getDispatch(GET_REFERAL_CANDI_TYPE, res));
    })
    .catch((err) => {
      dispatch(setErrorMessage(err));
    });
};


export const updateCandidateReferal = (data, back) => (dispatch) => {
  axios
    .put( REFERAL_CANDI_API , data, { withCredentials: true })
    .then((res) => {
      dispatch(setSuccessMessage(res, back));
    })
    .catch((err) => {
      dispatch(setErrorMessage(err));
    });
};

export const deleteCandidateReferal = (data) => (dispatch) => {
  axios
    .delete(REFERAL_CANDI_API, { data, withCredentials: true })
    .then((res) => {
      dispatch(setSuccessMessage(res, null, getCandidateReferal));
    })
    .catch((err) => {
      dispatch(setErrorMessage(err));
    });
};
